const EPSILON = 0.0001;

function num(value) {
  return value == null ? 0 : Number(value);
}

// Um campo e considerado "personalizado" da campanha quando difere do valor
// padrao da plataforma. Isso torna o merge estavel no reload e evita marcar
// campos como custom por conta de eventos de input disparados na carga.
export function differsFromDefault(value, defaultValue) {
  return Math.abs(num(value) - num(defaultValue)) > EPSILON;
}

export default class Tax {
  constructor(campaignId = null, paymentMethodProviderId = 0, defaultOnPlatform = false) {
    this.id = 0;
    this.campaignId = campaignId;
    this.paymentMethodProviderId = paymentMethodProviderId;
    this.defaultOnPlatform = defaultOnPlatform;

    this.ticketTaxValue = 0;
    this.pixTaxPercentualValue = 0;
    this.pixFixedValueLimit = 0;

    // baseline com o valor padrao da plataforma, usado para o merge/marcacao
    this.ticketTaxValueDefault = 0;
    this.pixTaxPercentualValueDefault = 0;
    this.pixFixedValueLimitDefault = 0;

    this.parcelamentsD2 = [];
    this.parcelamentsD30 = [];

    for (let i = 0; i < 12; i++) {
      this.parcelamentsD2.push(new TaxesParcelament(1, i + 1));
      this.parcelamentsD30.push(new TaxesParcelament(2, i + 1));
    }
  }

  // Base do merge: valores padrao da plataforma (define tambem o baseline).
  loadFromDefault(taxDefault) {
    if (!taxDefault) return;

    this.ticketTaxValue = this.ticketTaxValueDefault = num(taxDefault.ticketTaxValue);
    this.pixTaxPercentualValue = this.pixTaxPercentualValueDefault = num(taxDefault.pixTaxPercentualValue);
    this.pixFixedValueLimit = this.pixFixedValueLimitDefault = num(taxDefault.pixFixedValueLimit);

    this._applyDefaultParcelaments(taxDefault.parcelamentsD2, this.parcelamentsD2);
    this._applyDefaultParcelaments(taxDefault.parcelamentsD30, this.parcelamentsD30);
  }

  // Override esparso: sobrepoe os valores personalizados da campanha sobre a base.
  mergeCampaign(campaignTax) {
    if (!campaignTax) return;

    this.id = campaignTax.id || 0;

    if (campaignTax.ticketTaxValue != null) this.ticketTaxValue = num(campaignTax.ticketTaxValue);
    if (campaignTax.pixTaxPercentualValue != null) this.pixTaxPercentualValue = num(campaignTax.pixTaxPercentualValue);
    if (campaignTax.pixFixedValueLimit != null) this.pixFixedValueLimit = num(campaignTax.pixFixedValueLimit);

    this._applyCustomParcelaments(campaignTax.parcelamentsD2, this.parcelamentsD2);
    this._applyCustomParcelaments(campaignTax.parcelamentsD30, this.parcelamentsD30);
  }

  _applyDefaultParcelaments(source, target) {
    if (!source || !source.length) return;
    source.forEach((p) => {
      const item = target.find((t) => t.parcelamentNumber === p.parcelamentNumber);
      if (!item) return;
      item.taxPercentualValue = item.defaultValue = num(p.taxPercentualValue);
    });
  }

  _applyCustomParcelaments(source, target) {
    if (!source || !source.length) return;
    source.forEach((p) => {
      const item = target.find((t) => t.parcelamentNumber === p.parcelamentNumber);
      if (!item) return;
      item.taxPercentualValue = num(p.taxPercentualValue);
    });
  }
}

export class TaxesParcelament {
  constructor(receiverId = 0, parcelamentNumber = 0) {
    this.id = 0;
    this.taxId = 0;
    this.receiverId = receiverId;
    this.taxPercentualValue = 0;
    this.defaultValue = 0;
    this.parcelamentNumber = parcelamentNumber;
  }
}

// Indica se a taxa tem qualquer override em relacao ao padrao (ou ja possui uma
// linha custom persistida que precisa ser atualizada).
export function taxHasCustom(tax) {
  if (!tax) return false;
  return (
    !!(tax.id && tax.id > 0) ||
    differsFromDefault(tax.ticketTaxValue, tax.ticketTaxValueDefault) ||
    differsFromDefault(tax.pixTaxPercentualValue, tax.pixTaxPercentualValueDefault) ||
    differsFromDefault(tax.pixFixedValueLimit, tax.pixFixedValueLimitDefault) ||
    (tax.parcelamentsD2 || []).some((p) => differsFromDefault(p.taxPercentualValue, p.defaultValue)) ||
    (tax.parcelamentsD30 || []).some((p) => differsFromDefault(p.taxPercentualValue, p.defaultValue))
  );
}

// Monta o payload esparso: apenas os campos que diferem do padrao da plataforma
// sao enviados como override da campanha; os demais vao nulos/vazios e voltam a
// herdar o default no proximo load.
export function buildSparseTaxPayload(tax) {
  const mapCustom = (list) =>
    (list || [])
      .filter((p) => differsFromDefault(p.taxPercentualValue, p.defaultValue))
      .map((p) => ({
        id: 0,
        taxId: 0,
        receiverId: p.receiverId,
        parcelamentNumber: p.parcelamentNumber,
        taxPercentualValue: num(p.taxPercentualValue),
      }));

  return {
    id: tax.id || 0,
    campaignId: tax.campaignId ? parseInt(tax.campaignId, 10) : null,
    paymentMethodProviderId: tax.paymentMethodProviderId,
    defaultOnPlatform: false,
    ticketTaxValue: differsFromDefault(tax.ticketTaxValue, tax.ticketTaxValueDefault) ? num(tax.ticketTaxValue) : null,
    pixTaxPercentualValue: differsFromDefault(tax.pixTaxPercentualValue, tax.pixTaxPercentualValueDefault) ? num(tax.pixTaxPercentualValue) : null,
    pixFixedValueLimit: differsFromDefault(tax.pixFixedValueLimit, tax.pixFixedValueLimitDefault) ? num(tax.pixFixedValueLimit) : null,
    parcelamentsD2: mapCustom(tax.parcelamentsD2),
    parcelamentsD30: mapCustom(tax.parcelamentsD30),
  };
}
